var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9987 13.6668C3.3167 13.6668 0.332031 10.6822 0.332031 7.00016C0.332031 3.31816 3.3167 0.333496 6.9987 0.333496C10.6807 0.333496 13.6654 3.31816 13.6654 7.00016C13.6654 10.6822 10.6807 13.6668 6.9987 13.6668ZM5.47203 12.1115C4.81431 10.7164 4.43328 9.20697 4.35003 7.66683H1.7067C1.83642 8.69276 2.26131 9.65894 2.92974 10.448C3.59817 11.237 4.48137 11.8149 5.47203 12.1115ZM5.68536 7.66683C5.78603 9.29283 6.2507 10.8202 6.9987 12.1682C7.76691 10.7845 8.21566 9.24648 8.31203 7.66683H5.68536ZM12.2907 7.66683H9.64736C9.56412 9.20697 9.18309 10.7164 8.52536 12.1115C9.51602 11.8149 10.3992 11.237 11.0677 10.448C11.7361 9.65894 12.161 8.69276 12.2907 7.66683ZM1.7067 6.3335H4.35003C4.43328 4.79335 4.81431 3.28395 5.47203 1.88883C4.48137 2.18542 3.59817 2.76333 2.92974 3.55236C2.26131 4.34139 1.83642 5.30756 1.7067 6.3335ZM5.68603 6.3335H8.31136C8.2152 4.75389 7.76668 3.21585 6.9987 1.83216C6.23048 3.2158 5.78174 4.75384 5.68536 6.3335H5.68603ZM8.52536 1.88883C9.18309 3.28395 9.56412 4.79335 9.64736 6.3335H12.2907C12.161 5.30756 11.7361 4.34139 11.0677 3.55236C10.3992 2.76333 9.51602 2.18542 8.52536 1.88883Z",
    fill: "#1FAEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLive);
export default __webpack_public_path__ + "static/media/web-live.a64ef6dd7c0c09ded7f46d6e8d07ac96.svg";
export { ForwardRef as ReactComponent };